import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// components
import MenuItemOrigin from '@mui/material/MenuItem'
// themes
import { colors } from 'themes/index'
// constants
import { Modals } from 'constants/modals'
// types
import { IToken } from 'types/graphql'

const Wrapper = styled('div')`
  padding: 8px 0;
`

const MenuItem = styled(MenuItemOrigin)`
  && {
    color: ${colors.blue500};
    min-height: inherit;
    padding: 4px 12px;
  }
` as typeof MenuItemOrigin

interface Props {
  token: IToken
  closePopup: () => void
  handleDeleteClick: () => void
}

const Menu: React.FC<Props> = ({ token, closePopup, handleDeleteClick }) => {
  const { showModal } = useShowModal({ modalType: Modals.SYNC_RULES_MODAL })

  const handleDelete = () => {
    closePopup()
    handleDeleteClick()
  }

  const onSyncRulesClick = () => {
    closePopup()
    showModal({ token })
  }

  return (
    <Wrapper>
      <MenuItem onClick={onSyncRulesClick}>Sync Rules</MenuItem>
      <MenuItem onClick={handleDelete}>Delete</MenuItem>
    </Wrapper>
  )
}

export default Menu
